export default {
    data() {
        return {
            auth: null,
        };
    },
    components: {

    },
};


// WEBPACK FOOTER //
// ./src/pages/administration/banned/master/banned.js